// extracted by mini-css-extract-plugin
export default {"sticky":"FundingDirectionsFormTable_sticky__7XAFZ","totalRowTitleStyles":"FundingDirectionsFormTable_totalRowTitleStyles__cYMlB"};